import { configureStore } from '@reduxjs/toolkit'
import mainSlice from './main.slice'
import authorSlice from './author.slice'
import bookSlice from './book.slice'
import publisherSlice from './publisher.slice'
import userSlice from './user.slice'
import orderSlice from './order.slice'
import searchSlice from './search.slice'

const store = configureStore({
  reducer: {
    author: authorSlice.reducer,
    main: mainSlice.reducer,
    book: bookSlice.reducer,
    publisher: publisherSlice.reducer,
    user: userSlice.reducer,
    order: orderSlice.reducer,
    search: searchSlice.reducer,
    // comment: commentReducer,
    // basket: basketReducer,
    // payment: paymentReducer
  },
})

export type RootState = ReturnType<typeof store.getState>

export default store
